import PropTypes from 'prop-types';
import useRedux from 'infrastructure/js/hooks/useRedux';

const getState = (state) => {
  let dialog = state.dialogs?.get('commonDialog');

  if (!dialog) {
    return {
      activeDialog: null,
      dialogState: null,
    };
  }

  return {
    activeDialog: dialog.get('activeDialog') ?? null,
    dialogState: dialog,
  };
};

function CommonDialogWrapper({
                              dialogName,
                              dialogComponent: DialogComponent,
                              ...rest
                                            }) {
  const { state } = useRedux({}, getState);
  const {activeDialog, dialogState } = state;

  if (activeDialog !== dialogName) {
    return null;
  }
  return <DialogComponent {...rest} sData={dialogState} />;
}

CommonDialogWrapper.propTypes = {
  dialogName: PropTypes.string.isRequired,
  dialogComponent: PropTypes.elementType.isRequired,
};

export default CommonDialogWrapper;

